import { Box, Typography } from "@mui/material";

export const severities = [
  "Emergency",
  "Alert",
  "Critical",
  "Error",
  "Warning",
  "Notice",
  "Informational",
  "Debug",
];

const Severity = ({ severity, variant = "body1", fontWeight = "400" }) => {
  const fallback = () =>
    severity
      ? (severities.find((it) => it.toLowerCase() === severity.toLowerCase()) ??
        "")
      : "";

  return (
    <Box>
      <Typography variant={variant} fontSize={"13px"} fontWeight={fontWeight}>
        {severities[severity] ?? fallback()}
      </Typography>
    </Box>
  );
};

export default Severity;
